import {
    ADD_WALLET_DETAILS_START,
    ADD_WALLET_DETAILS_SUCCESS,
    ADD_WALLET_DETAILS_ERROR
} from '../../constants';
import { setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { confirmPaymentIntent } from './confirmPaymentIntent';
import { addWallet as mutation, getPaymentMethod as query } from '../../lib/graphql';
import { getCurrencySymbol } from '../../helpers/currencyConvertion';
import { updatePaypalCurrency } from '../payment/updatePaypalCurrency';
import history from '../../history';

export function addWalletDetails({ stripe, amount, currency, paymentMethodId, cardLastFour, paymentType, orderId, bookingId, paymentCurrency }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: ADD_WALLET_DETAILS_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    amount: parseFloat(amount),
                    currency,
                    paymentMethod: paymentMethodId,
                    paymentType: Number(paymentType),
                    orderId,
                    bookingId,
                    paymentCurrency
                },
                refetchQueries: [{ query }]
            });
            let symbol = getCurrencySymbol(currency), walletAmount = amount + symbol;

            if (data?.addWallet?.status === '200') {
                if (data?.addWallet?.requireAdditionalAction) {
                    const { error: actionError, paymentIntent } = await stripe.handleCardAction(data?.addWallet?.paymentIntentSecret);
                    if (actionError) {
                        showToaster({ messageId: 'catchMessage', requestContent: actionError.message, toasterType: 'error' });
                        dispatch(setLoaderComplete('addCardDetails'));
                    } else if (paymentIntent?.status === 'requires_confirmation') {
                        const paymentIntentId = paymentIntent?.id;
                        dispatch(confirmPaymentIntent({ paymentIntentId, cardLastFour, amount, currency, orderId, bookingId }))
                    }
                    dispatch({
                        type: ADD_WALLET_DETAILS_ERROR,
                    });
                } else if (data?.addWallet?.redirectURL) {
                    await dispatch(updatePaypalCurrency({ currency }));
                    window.location = data?.addWallet?.redirectURL
                    return;
                } else {

                    dispatch(setLoaderComplete('addCardDetails'))
                    orderId
                        ? history.push(`/order/${orderId}`)
                        : (bookingId
                            ? history.push(`/tracking/${bookingId}`)
                            : history.push('/payment-method'));
                    let requestContent = walletAmount
                    await showToaster({ messageId: 'walletAmountAdded', requestContent, toasterType: 'success' });
                    dispatch({
                        type: ADD_WALLET_DETAILS_SUCCESS,
                    });
                }
            } else {
                let errorMessage = data?.addWallet?.errorMessage
                showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
                dispatch(setLoaderComplete('addCardDetails'));
            }
        } catch (error) {
            dispatch({
                type: ADD_WALLET_DETAILS_ERROR,
            });
            dispatch(setLoaderComplete('addCardDetails'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}